export const appConfig = {
  rootUrl: 'https://provider-portal-prod-api.azurewebsites.net/api',
  // rootUrl: 'https://providerportal-qa-api.tutelarhealth.io/api',
  // rootUrl: 'https://providerportalapi.allyalign.com/api',
};
